module.exports = __webpack_public_path__ + "static/media/cms.134c9b93.png";